import React, { useEffect } from "react";

import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import FormControl from "@mui/material/FormControl";

import PriceField from "Components/UI/Form/PriceField";
import DateWithClear from "Components/UI/Form/DateWithClear";
import dayjs from "dayjs";

import FilesCombobox from "Components/Files/FilesCombobox";
import { useAccountCharts } from "Context/AccountCharts";
import SelectWithClear from "Components/UI/Form/SelectWithClear";
import { MenuItem } from "@mui/material";

export default function General({
  formData,
  FORM_MODE,
  handleInputChange,
  allBooks,
}) {
  const { fetchAccountCharts, accountCharts } = useAccountCharts();

  useEffect(() => {
    if (!accountCharts || accountCharts.length === 0) {
      fetchAccountCharts();
    }
  }, [accountCharts]);

  return (
    <>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={6} md={4}>
          <TextField
            disabled
            name="Id"
            label="ID"
            value={formData?.Id}
            size="small"
            fullWidth
            margin="dense"
          />
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <PriceField
            name="DebetAmount"
            label="Debet belopp"
            value={formData?.DebetAmount === null ? 0 : formData?.DebetAmount}
            disabled={FORM_MODE === "LOCKED" ? true : false}
            onChange={(newVal) => handleInputChange("DebetAmount", newVal)}
            size="small"
            color="primary"
            fullWidth
            margin="dense"
            type="number"
          />
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <PriceField
            name="KreditAmount"
            label="Kredit belopp"
            value={formData?.KreditAmount === null ? 0 : formData?.KreditAmount}
            disabled={FORM_MODE === "LOCKED" ? true : false}
            onChange={(newVal) => handleInputChange("KreditAmount", newVal)}
            size="small"
            color="primary"
            fullWidth
            margin="dense"
            type="number"
          />
        </Grid>

        <Grid item xs={12} sm={6} md={4}>
          <FormControl fullWidth margin="dense" sx={{ textAlign: "left" }}>
            <SelectWithClear
              name="DebetAccount"
              label="Debet konto"
              disabled={FORM_MODE === "LOCKED"}
              value={formData.DebitAccountChartId}
              onChange={(e) =>
                handleInputChange("DebitAccountChartId", e.target.value)
              }
            >
              {accountCharts.map((accountChart) => (
                <MenuItem key={accountChart.Id} value={accountChart.Id}>
                  {`${accountChart.AccountNumber} - ${accountChart.Name}`}
                </MenuItem>
              ))}
            </SelectWithClear>
          </FormControl>
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <FormControl fullWidth margin="dense" sx={{ textAlign: "left" }}>
            <SelectWithClear
              name="CreditAccount"
              label="Kredit konto"
              disabled={FORM_MODE === "LOCKED"}
              value={formData.CreditAccountChartId}
              onChange={(e) =>
                handleInputChange("CreditAccountChartId", e.target.value)
              }
            >
              {accountCharts.map((accountChart) => (
                <MenuItem key={accountChart.Id} value={accountChart.Id}>
                  {`${accountChart.AccountNumber} - ${accountChart.Name}`}
                </MenuItem>
              ))}
            </SelectWithClear>
          </FormControl>
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <PriceField
            name="BookGroupId"
            label="Grupp"
            value={formData?.BookGroupId === null ? 0 : formData?.BookGroupId}
            disabled={FORM_MODE === "LOCKED" ? true : false}
            onChange={(newVal) => handleInputChange("BookGroupId", newVal)}
            size="small"
            color="primary"
            fullWidth
            margin="dense"
            type="number"
          />
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <FilesCombobox
            disabled={FORM_MODE === "LOCKED" ? true : false}
            label={"Bokföringsfil"}
            files={allBooks}
            selectedFileID={formData.FileId ? formData.FileId : null}
            onChange={(newVal) => handleInputChange("FileId", newVal)}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <DateWithClear
            label="Bokföringsdatum"
            value={dayjs(formData.BookDate)}
            disabled={FORM_MODE === "LOCKED" ? true : false}
            onChange={(newVal) =>
              handleInputChange("BookDate", dayjs(newVal).format("YYYY-MM-DD"))
            }
          />
        </Grid>
      </Grid>
    </>
  );
}
